import brand from '@helpers/brand';
import { Device, between, from, until } from '@helpers/media';
import { PageTheme } from '@helpers/themeEnum';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) `
  position: absolute;
  z-index: -1;
  top: 0;
  width: 100%;
  height: 100%;
  color: var(--primaryPageThemeColorLight);
  overflow: clip;

  @media ${until(Device.TabletLarge)} {
    transform: translateY(50vh) !important; // override js inline style
    height: calc(100% - 50vh) !important; // override js inline style
  }

  body[data-page-theme=${PageTheme.Grey}] & {
    --primaryPageThemeColorLight: ${brand.blue.light};
  }
`;
const Svg = styled.svg `
  &[data-background='desktop'] {
    display: none;

    @media ${from(Device.TabletLarge)} {
      display: block;
    }
  }

  &[data-background='mobile'] {
    display: block;

    @media ${from(Device.TabletLarge)} {
      display: none;
    }

    @media ${between(Device.MobileLarge, Device.TabletLarge)} {
      path {
        stroke-width: 30;
      }
    }
  }
`;
const PathwayStyles = {
    Container,
    Svg,
};
export default PathwayStyles;
